import {FetchBaseQueryError} from "@reduxjs/toolkit/query";
import {SerializedError} from "@reduxjs/toolkit";
import React, {useState} from "react";
import {Alert, Snackbar} from "@mui/material";

type SnackProps = {
    error?: FetchBaseQueryError | SerializedError | undefined,
    message?: string
    color?: 'error' | 'info' | 'success' | 'warning'
}

const makeMsg = (error: any): string => {
    let msg = ""
    if (typeof error === "string") {
        return error
    }
    if (typeof error === "object") {
        const m: Record<string, string | Array<string>> = error;

        for (const i in m) {
            const seri = (i: string | Array<string>) => {
                if (typeof i === "string") return i;
                return i.reduce((a, e) => a + (msg ? ", " : "") + e)
            }
            msg += (msg ? ", " : "") + i + ": " + seri(m[i])
        }
    }


    return msg;
}
export default function SnackError({error, message, color = "error"}: SnackProps) {
    const [open, setOpen] = useState<boolean>(true);

    if (error === undefined) {
        return null;
    }
    let msg = "";
    if (typeof message === "string") {
        msg = message
    }

    if (typeof error === "object" && error !== null) {
        if ("message" in error) {
            if (typeof error.message === "string") {
                msg = error.message;
            }
        }
    }
    return <Snackbar
        open={open}
        onClose={() => setOpen(false)}
        autoHideDuration={6000}>
        <Alert severity={color}>{msg}</Alert>
    </Snackbar>;
}
